var BaseViews = require('../../../common/base');
require('./potency-display/potency-display.scss');
var PotencyDisplayView = BaseViews.LayoutView.extend({
    className: 'fmcy-potency-display',
    template: require('./potency-display/potency-display.html'),
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
                size: 'small',
                filterLocation: null, //'hillsidevictoria'
            }
        );
    },
    serializeData: function () {
        var self = this;

        this.potency_max_cbd = null;
        this.potency_max_thc = null;
        this.potency_mg_pct = null;
        this.potency_min_cbd = null;
        this.potency_min_thc = null;
        this.potency_terps = null;
        
        this.model.get('variants').each(function (model) {
          _.each(model.get('locations'), function (location) {
            if (location.slug === self.options.filterLocation) {
              if (location.potency_mg_pct == 'M' || location.potency_mg_pct == 'P') {
                self.potency_mg_pct = location.potency_mg_pct;
              }

              
              if (location.potency_terps && location.potency_terps !== null && parseFloat(location.potency_terps) > 0) {
                self.potency_terps = parseFloat(location.potency_terps);
              }
              

              // set min THC
              if (self.potency_min_thc == null || self.potency_min_thc == 0) {
                self.potency_min_thc = parseFloat(location.potency_min_thc);
              } else {
                // is the potency less then current min set it lower...
                if (parseFloat(location.potency_min_thc) > 0 && (self.potency_min_thc > parseFloat(location.potency_min_thc))) {
                  self.potency_min_thc = parseFloat(location.potency_min_thc);
                }
              }

              // set max THC
              if (self.potency_max_thc == null || self.potency_max_thc == 0) {
                self.potency_max_thc = parseFloat(location.potency_max_thc);
              } else {
                // is the potency more then current max set it higher...
                if (self.potency_max_thc < parseFloat(location.potency_max_thc)) {
                  self.potency_max_thc = parseFloat(location.potency_max_thc);
                }
              }

              // set min CBD
              if (self.potency_min_cbd == null || self.potency_min_cbd == 0) {
                self.potency_min_cbd = parseFloat(location.potency_min_cbd);
              } else {
                // is the potency less then current min set it lower...
                if (parseFloat(location.potency_min_cbd) > 0 && (self.potency_min_cbd > parseFloat(location.potency_min_cbd))) {
                  self.potency_min_cbd = parseFloat(location.potency_min_cbd);
                }
              }

              // set max CBD
              if (self.potency_max_cbd == null || self.potency_max_cbd == 0) {
                self.potency_max_cbd = parseFloat(location.potency_max_cbd);
              } else {
                // is the potency more then current max set it higher...
                if (self.potency_max_cbd < parseFloat(location.potency_max_cbd)) {
                  self.potency_max_cbd = parseFloat(location.potency_max_cbd);
                }
              }
            } // end if slug == filter location
          }); // end each model get locations
        });

        var potencyText = '';
        var potencyTHCText = '';
        var potencyCBDText = '';
        var potencyTerpText = '';
        var potencyArray = [];

        if (this.potency_min_thc !== 0 && this.potency_max_thc !== 0) {
          potencyTHCText = 'THC ';

          if (this.potency_min_thc == this.potency_max_thc) {
            potencyTHCText += this.potency_max_thc;
          } else {
            potencyTHCText += this.potency_min_thc + ' - ' + this.potency_max_thc;
          }

          if (this.potency_mg_pct == 'P') {
            potencyTHCText += '%';
          } else {
            potencyTHCText += 'mg';
          }
          potencyArray.push(potencyTHCText);
        }

        if (this.potency_min_cbd !== 0 && this.potency_max_cbd !== 0 && parseFloat(this.potency_max_cbd) >= 1) {
          potencyCBDText = 'CBD ';
          if (this.potency_min_cbd == this.potency_max_cbd) {
            potencyCBDText += this.potency_max_cbd;
          } else {
            potencyCBDText += this.potency_min_cbd + ' - ' + this.potency_max_cbd;
          }
          if (this.potency_mg_pct == 'P') {
            potencyCBDText += '%';
          } else {
            potencyCBDText += 'mg';
          }
          potencyArray.push(potencyCBDText);
        }

        if (self.potency_terps !== null && self.potency_terps > 0) {
          potencyTerpText = 'TERPS ';
          potencyTerpText += self.potency_terps + '%';
          potencyArray.push(potencyTerpText);
        }

        potencyArray.forEach(function (text, index) {
          potencyText += text;
          if (potencyArray.length > 1 && index != (potencyArray.length - 1)) {
            potencyText += ' | ';
          }
        });

        return {
            potencyText: potencyText
        };
    }
});

module.exports = PotencyDisplayView;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/potency-display.js
 **/